import { render, staticRenderFns } from "./OG.vue?vue&type=template&id=650bc78f&scoped=true&"
import script from "./OG.vue?vue&type=script&lang=js&"
export * from "./OG.vue?vue&type=script&lang=js&"
import style0 from "./OG.vue?vue&type=style&index=0&id=650bc78f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650bc78f",
  null
  
)

export default component.exports